module.exports = __webpack_public_path__ + "static/ma-3-7c73c887066a41ee5f7af7ee3a4b0e28.png";